import React, { useEffect, useState } from "react";
import { Gear } from "react-bootstrap-icons";
import CardDropdown from "components/common/CardDropdown";
import { Card, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faFileExcel,
  faRecycle,
  faCheckDouble,
  faCheck,
  faTimes,
  faClock,
  faInfoCircle,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import useAdvanceTable from "hooks/useAdvanceTable";
import FalconPagination from "components/common/custom/pagination";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import SubtleBadge from "components/common/SubtleBadge";
import { useDispatch } from "react-redux";
import { MultipleClearPayment, SingleClearPayment, ViewSinglePayment } from "../config/PaymentApi";
import { Button } from "react-bootstrap";
import Flex from "components/common/Flex";
import ClaimViewSinglePayment from "./ClaimViewSinglePayment";
import PaymentClearConfirmationModal from "./PaymentClearConfirmationModal";
import PaymentMultiClearConfirmationModal from "./PaymentMultiClearConfirmationModal";
import PaymentMultiClearErrorModal from "./PaymentMultiClearErrorModal";
import { handleDownloadXLSX } from "helpers/excel/index.js";

const PaymentListTable = ({
  data,
  page,
  rowsPerPage,
  totalRows,
  handlePageChange,
  fetchPaymentList,
  requestBody,
  handlePerRowsChange,
}) => {
  const dispatch = useDispatch();
  console.log({ requestBody })
  const [singlePaymentData, setSinglePaymentData] = useState([]);
  const [show, setShow] = useState(false);
  const [showClearModal, setShowClearModal] = useState(false);
  const [showMultiClearModal, setShowMultiClearModal] = useState(false);
  const [showMultiErrorModal, setShowMultiErrorModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const handleOpenClearModal = (payment) => {
    setSelectedPayment(payment);
    setShowClearModal(true);
  };

  const handleCloseClearModal = () => {
    setShowClearModal(false);
    setSelectedPayment(null);
  };

  const handleConfirmClear = () => {
    const body = {
      paymentno: selectedPayment?.paymentno,
    }
    dispatch(SingleClearPayment(body)).unwrap().then(({ data }) => {
      fetchPaymentList(requestBody)
    })
    handleCloseClearModal();
  };

  const handleBulkClear = () => {
    const selectedRows = table.getSelectedRowModel().rows;
    const allPaid = selectedRows.every(row => row.original.pay_status?.toLowerCase() === "paid");

    if (allPaid) {
      setShowMultiClearModal(true);
    } else {
      setShowMultiErrorModal(true);
    }
  };

  const handleConfirmMultiClear = () => {
    const selectedRowsData = table.getSelectedRowModel().rows.map(row => row.original);
    table.resetRowSelection();

    const body = {
      paynotice: selectedRowsData?.map(row => ({
        paymentno: row.paymentno,
      }))
    };

    dispatch(MultipleClearPayment(body)).unwrap().then(() => {
      fetchPaymentList(requestBody);
    });

    setShowMultiClearModal(false);
  };

  const handleDownloadRequestJson = (row) => {
    const fileUrl = row?.response_file;
    if (!fileUrl) {
      return;
    }

    // Attempt to download the file
    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) return;
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // Use the filename from the URL or a default
        const fileName = fileUrl.split("/").pop() || `${row.paymentno || "payment"}_response.json`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((error) => {
        window.open(fileUrl, "_blank");
      });
  };

  const handleExportExcel = async (row) => {
    dispatch(ViewSinglePayment({
      paymentno: row.paymentno || '',
    })).unwrap().then((response) => {
      if (response?.success) {
        const payment = response?.data?.payment_summary || {};
        const reconData = response?.data?.payment_recon || [];

        const summaryRows = [
          ["Payment Summary"],
          [],
          ["Payment No.", payment?.paymentno || ""],
          ["Amount", payment?.paymentamount || ""],
          ["Period Start", payment?.periodstart ? moment(payment.periodstart).format("DD-MM-YYYY") : ""],
          ["Period End", payment?.periodend ? moment(payment.periodend).format("DD-MM-YYYY") : ""],
          ["Payment Date", payment?.paymentdate ? moment(payment.paymentdate).format("DD-MM-YYYY") : ""],
          ["Disposition", payment?.disposition || ""],
          ["Payment Method", payment?.paymentmethod || ""],
          ["Payment Via", payment?.paymentmethodval || ""],
          ["Payment Ref No.", payment?.paymentmethodurl || ""],
          [],
          ["Payment Claims Detail"],
          [],
        ];

        const reconHeader = [
          "#",
          "Claim Number",
          "Claim Date",
          "Insurance Code",
          "Amount",
          "Payment Fee",
          "Early Fee",
          "Nphies Fee",
          "Payment Type",
          "Bundle Request Id",
          "Bundle Response Id",
          "Status"
        ];

        const reconRows = reconData.map((item, index) => [
          index + 1,
          item?.pollsabout || "",
          payment?.paymentdate ? moment(payment.paymentdate).format("DD-MM-YYYY") : "",
          item?.insurance_code || "",
          item?.amount || "",
          item?.payment || "",
          item?.earlyfee || "",
          item?.nphiesfee || "",
          item?.paymenttype || "",
          item?.claim_req_bundleid || "",
          item?.claim_resp_bundleid || "",
          item?.claim_status || ""
        ]);

        handleDownloadXLSX(
          [
            ...summaryRows,
            reconHeader,
            ...reconRows
          ],
          `Payment_Detail_${row.paymentno || moment().format("DD-MM-YYYY_hh:mm:ss")}`
        );
      }
    });
  };

  const handleViewSinglePayment = async (row) => {
    console.log({ row });
    dispatch(ViewSinglePayment({
      paymentno: row.paymentno || '',
    })).unwrap().then((data) => {
      console.log({ data })
      if (data?.success) {
        setShow(true)
        setSinglePaymentData(data?.data);
      }
    })
  }


  const columns = [

    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center ">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "insurance_shname",
      header: "Payer",
      cell: ({ row: { original } }) => (
        <div className="fs-11 ">
          {original.insurance_direct === 0
            ? `${original.payer_name} - ${original.insurance_shname}`
            : original.payer_name}
        </div>
      ),
    },
    {
      accessorKey: "claim_date",
      header: "Payment Date",
      cell: ({ row: { original } }) => (
        <div className="fs-11 ">
          {original.paymentdate ? moment(original.paymentdate).format("DD-MM-YYYY") : ""}
        </div>
      ),
    },
    {
      accessorKey: "insurance_code",
      header: "Insurance Code",
      cell: ({ row: { original } }) => (
        <div className="fs-11">{original?.insurance_code || ""}</div>
      ),
    },
    {
      accessorKey: "paymentno",
      header: "Payment No.",
      cell: ({ row: { original } }) => (
        <div className="fs-11">{original?.paymentno || ""}</div>
      ),
    },
    {
      accessorKey: "start_date",
      header: "Period Start Date",
      cell: ({ row: { original } }) => (
        <div className="fs-11">{original?.start_date ? moment(original?.start_date).format("DD-MM-YYYY") : ""}</div>
      ),
    },

    {
      accessorKey: "end_date",
      header: "Period End Date",
      cell: ({ row: { original } }) => original?.end_date ? moment(original?.end_date).format("DD-MM-YYYY") : "",
    },
    {
      accessorKey: "amount",
      header: "Amount",
      cell: ({ row: { original } }) => {
        const value = parseFloat(original.amount);
        return (
          <div className="fs-11 ">{isNaN(value) ? "-" : value.toFixed(2)}</div>
        );
      },
    },
    {
      accessorKey: "totalclaim",
      header: "Claims Count",
      cell: ({ row: { original } }) => (
        <div className="fs-11 text-center">{original?.totalclaim || 0}</div>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row: { original } }) => {
        const value = original.pay_status?.toLowerCase();
        const statusConfig = {
          paid: { bg: "#E3F9F0", color: "#00A86B", icon: faCheck },
          verified: { bg: "#E1F5FE", color: "#0288D1", icon: faCheckDouble },
          pending: { bg: "#FFF4E5", color: "#FF9800", icon: faClock },
          failed: { bg: "#FEEBEE", color: "#D32F2F", icon: faTimes },
          cleared: { bg: "#F3E5F5", color: "#8E24AA", icon: faRecycle },
        };

        const config = statusConfig[value] || {
          bg: "#F5F7FA",
          color: "#718096",
          icon: faInfoCircle,
        };

        return (
          <div className="d-flex">
            <SubtleBadge
              pill
              style={{
                backgroundColor: config.bg,
                color: config.color,
                border: `1px solid ${config.color}20`,
                width: "120px",
              }}
              className="d-flex flex-center fs-11 p-2 gap-1"
            >
              <FontAwesomeIcon icon={config.icon} transform="shrink-2" className="ms-1 fa-10 me-1" />
              {original.pay_status || "-"}
            </SubtleBadge>
          </div>
        );
      },
    },
    {
      id: "actions",
      header: <Gear />,
      cell: ({ row: { original } }) => (
        <CardDropdown
          icon="ellipsis-v"
          dropdownClassName="py-2 custom-dropdown-menu"
        >
          <Dropdown.Item onClick={() => handleViewSinglePayment(original)}>
            <FontAwesomeIcon icon={faEye} className="me-2" />
            View
          </Dropdown.Item>
          {/* <Dropdown.Item>
            <FontAwesomeIcon icon={faCheckDouble} className="me-2" />
            Mark as paid
          </Dropdown.Item> */}
          {original?.pay_status?.toLowerCase() === "paid" && <Dropdown.Item onClick={() => handleOpenClearModal(original)}>
            <FontAwesomeIcon icon={faRecycle} className="me-2" />
            Mark as cleared
          </Dropdown.Item>}
          <Dropdown.Item onClick={() => handleExportExcel(original)}>
            <FontAwesomeIcon icon={faFileExcel} className="me-2" />
            Export as excel
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleDownloadRequestJson(original)}>
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            Download Request Json
          </Dropdown.Item>

        </CardDropdown>
      ),
    },
  ];
  const table = useAdvanceTable({
    data,
    columns,
    selection: true,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);
  return (
    <div className="mb-3 mt-3 border p-3  rounded-3 shadow-sm">
      {Object.keys(table.getState().rowSelection).length > 0 && (
        <Flex alignItems="center" className="mb-3 p-2 bg-subtle-primary rounded-2 animate__animated animate__fadeIn">
          <span className="fs-10 fw-semi-bold text-primary me-auto">

          </span>
          <Button
            variant="primary"
            size="sm"
            className="px-4 py-1 shadow-none"
            onClick={handleBulkClear}
          >
            <FontAwesomeIcon icon={faRecycle} className="me-2" />
            Mark as Cleared
          </Button>
        </Flex>
      )}
      {data?.length > 0 ? (
        <>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
                hover: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
          <ClaimViewSinglePayment
            show={show}
            setShow={setShow}
            data={singlePaymentData}
          />
          <PaymentClearConfirmationModal
            show={showClearModal}
            onClose={handleCloseClearModal}
            onConfirm={handleConfirmClear}
            selectedPayment={selectedPayment}
          />

          <PaymentMultiClearConfirmationModal
            show={showMultiClearModal}
            onClose={() => setShowMultiClearModal(false)}
            onConfirm={handleConfirmMultiClear}
            selectedCount={Object.keys(table.getState().rowSelection).length}
          />

          <PaymentMultiClearErrorModal
            show={showMultiErrorModal}
            onClose={() => setShowMultiErrorModal(false)}
          />
        </>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
    </div>
  );
};

export default PaymentListTable;
